<template>
  <div>
    <b-carousel
      v-model="slide"
      :interval="4000"
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <div v-for="(banner, index) in banners" v-bind:key="index">
        <b-carousel-slide :img-src="banner.image" :caption="banner.name"></b-carousel-slide>
      </div>
    </b-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      banners: []
    };
  },
  created: function() {
    this.get_banners();
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    get_banners() {
      let url = "about/banners/?ordering=index";
      this.$http.get(url).then(response => {
        this.banners = response.data;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
